import { SettingConst } from '@faire/web-api--source/types';

/**
 * Migrating signup code to app router as part of micro-fe work
 */
export const NEXTJS_MIGRATE_SIGNUP_APP_ROUTER_250210 =
  'NEXTJS_MIGRATE_SIGNUP_APP_ROUTER_250210' as SettingConst<
    'NEXTJS_MIGRATE_SIGNUP_APP_ROUTER_250210',
    boolean,
    'RETAILER' | 'HOTJAR_RETAILER' | 'VISITOR_WEB' | 'HOTJAR_VISITOR_WEB'
  >;
